import * as React from 'react'
import { motion } from 'framer-motion'
import { Box, SxProps } from '@mui/material'
import { useAnimationStyles } from 'src/Libs/live-view'
import EnergyFlowIndicatorSvg from './EnergyFlowIndicatorSvg'

export interface ArrowSvgProps {
  transform: string
  direction?: 'in' | 'out'
  doRotateBy180Deg?: boolean
  sx?: SxProps
}

const CurvedBottomArrowXxsSvg: React.FC<ArrowSvgProps> = ({ direction, transform, doRotateBy180Deg = false, sx }) => {
  const { classes, cx } = useAnimationStyles({ direction })

  return (
    <Box sx={{ position: 'relative', transform, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="96" height="52" viewBox="0 0 96 52" fill="none">
        <g id="livevalue_arrows">
          <motion.g id="line">
            <path
              d="M7.49976 50L7.49976 29.5067C7.49976 21.2225 14.2155 14.5067 22.4998 14.5067L81.7464 14.5067C85.4761 14.5067 88.4997 11.4831 88.4996 7.75337V7.75337L88.4994 1"
              stroke="#A4AAAE"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </motion.g>
          {direction === 'in' && (
            <g id="arrow_in_curved_side_arrow">
              <path
                d="M81.2928 6.79177L81.2245 6.86704C80.9039 7.25982 80.9267 7.8398 81.2928 8.20599C81.659 8.57217 82.239 8.59488 82.6318 8.27435L82.707 8.20599L89.2057 1.70737C89.5962 1.31685 89.5962 0.683681 89.2057 0.293157C88.8151 -0.0973673 88.182 -0.0973673 87.7914 0.293157L81.2928 6.79177Z"
                fill="#A4AAAE"
              />
              <path
                d="M94.2935 8.20722L94.3695 8.27627C94.7623 8.59645 95.3417 8.57327 95.7078 8.20722C96.0983 7.81669 96.0983 7.18353 95.7078 6.793L89.2078 0.293007C88.8172 -0.097517 88.1841 -0.097518 87.7936 0.293006C87.403 0.68353 87.403 1.3167 87.7936 1.70722L94.2935 8.20722Z"
                fill="#A4AAAE"
              />
            </g>
          )}
          {direction === 'out' && (
            <g id="arrow_out_curved_side_arrow">
              <path
                d="M14.7077 45.2085L14.776 45.1332C15.0966 44.7404 15.0738 44.1604 14.7077 43.7943C14.3415 43.4281 13.7615 43.4054 13.3687 43.7259L13.2934 43.7943L6.79482 50.2929C6.4043 50.6834 6.4043 51.3166 6.79482 51.7071C7.18535 52.0976 7.81851 52.0976 8.20904 51.7071L14.7077 45.2085Z"
                fill="#A4AAAE"
              />
              <path
                d="M1.70694 43.793L1.63098 43.724C1.23821 43.4038 0.658781 43.427 0.292726 43.793C-0.0977975 44.1835 -0.0977975 44.8167 0.292726 45.2072L6.79272 51.7072C7.18325 52.0978 7.81641 52.0978 8.20693 51.7072C8.59746 51.3167 8.59746 50.6835 8.20693 50.293L1.70694 43.793Z"
                fill="#A4AAAE"
              />
            </g>
          )}
        </g>
      </svg>
      {!!direction && (
        <EnergyFlowIndicatorSvg
          className={cx(classes.directionIndicator, classes.curvedSideArrowAnimation)}
          doRotateBy180Deg={doRotateBy180Deg}
          direction={direction}
        />
      )}
    </Box>
  )
}

export default CurvedBottomArrowXxsSvg
